'use client';

export default function OneSystemSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Label */}
        <p
          className="text-xs font-semibold uppercase tracking-widest mb-6"
          style={{ color: 'var(--color-accent)', fontFamily: "'Titillium Web', sans-serif" }}
        >
          WHY UNIFYMAX
        </p>

        {/* Main Heading */}
        <h2
          className="text-4xl sm:text-5xl font-bold leading-tight mb-8 max-w-3xl"
          style={{ color: '#000', fontFamily: "'Titillium Web', sans-serif" }}
        >
          One system. Many interactions. Real business outcomes.
        </h2>

        {/* Description Paragraph */}
        <p
          className="text-base sm:text-lg leading-relaxed mb-8 max-w-2xl"
          style={{ color: 'var(--color-foreground)' }}
        >
          UnifyMax unifies your{' '}
          <span style={{ color: 'var(--color-accent)', fontWeight: 600 }}>
            sales, support, digital, video, and physical touchpoints
          </span>{' '}
          into a single intelligent platform — driving{' '}
          <span style={{ color: 'var(--color-accent)', fontWeight: 600 }}>
            revenue growth, higher customer lifetime value, and repeat purchases
          </span>{' '}
          at every stage of the customer journey.
        </p>

        {/* Highlight Info Box */}
        <div
          className="rounded-xl px-7 py-6 shadow-sm max-w-2xl"
          style={{
            background: 'var(--color-surface)',
            borderLeft: '4px solid var(--color-accent)',
          }}
        >
          <p
            className="text-base sm:text-lg leading-relaxed"
            style={{ color: 'var(--color-foreground)' }}
          >
            Great CX is no longer about tools. It's orchestrated through a{' '}
            <strong>single, intelligent system</strong> that{' '}
            <strong>eliminates silos</strong> and turns every touchpoint into compounding growth.
          </p>
        </div>
      </div>
    </section>
  );
}
